import script from "./BaseCheckbox.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseCheckbox.vue?vue&type=script&setup=true&lang=ts"

import "./BaseCheckbox.vue?vue&type=style&index=0&id=3eb46b9e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3eb46b9e"]])

export default __exports__